module.exports = __webpack_public_path__ + "static/img/ask_bg.b4212b2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mobile/ask_bg.png
// module id = 3vI9
// module chunks = 192